import { type AnswerGenerationModel } from './types';

/**
 * Extracts the model name from the answer generation model object.
 * Returns the first key from model_usage or 'null' if not available.
 */
export const extractModelName = (
	answerGenerationModel: AnswerGenerationModel | undefined,
): string => {
	if (answerGenerationModel?.model_usage && typeof answerGenerationModel.model_usage === 'object') {
		const keys = Object.keys(answerGenerationModel.model_usage);
		return keys[0] ?? 'null';
	}
	return 'null';
};
